import React from "react";
import {domToReact} from "html-react-parser";
import InteractiveSvgWrapper from "../../../interactive_svg/interactive_svg_wrapper";

const RenderedInteractiveSvgWrapper = ({node, options}) => {
  const zoom = Number(node.attribs["data-zoom"]) || 5
  const overflow = node.attribs["data-overflow"] || "hidden"
  const targetElementId = node.attribs["data-target-element-id"]

  return <InteractiveSvgWrapper
    zoom={zoom}
    style={{overflow: overflow}}
    elementId={targetElementId}
  >
    {domToReact(node.children, options)}
  </InteractiveSvgWrapper>
}

export default RenderedInteractiveSvgWrapper